module.exports = __webpack_public_path__ + "img/m.8f2911f2.jpg";